export enum OrganisationTypeRole {
  'CODE_REQUESTER_ALL' = 'CODE_REQUESTER_ALL',
  'CODE_REQUESTER_AUIS' = 'CODE_REQUESTER_AUIS',
  'NOT_CODE_REQUESTER' = 'NOT_CODE_REQUESTER',
  'SERVICE_PROVIDER' = 'SERVICE_PROVIDER',
  'STANDARD' = 'STANDARD',
  'ADVANCED' = 'ADVANCED',
  'FIELD_INSPECTOR' = 'FIELD_INSPECTOR',
  'GOV_ADMIN' = 'GOV_ADMIN',
  'ADMIN_DENTSU' = 'ADMIN_DENTSU'
}